import React, { useEffect, useState } from "react";

import moment from "moment";

import { ObservabilityPipelineHttpMetricsOverview } from "Api/observability/pipeline/types";

import useObservabilityPipelineHttpClient from "../hooks/useObservabilityPipelineHttpClient";

type LoadState = "ready" | "loading" | "loaded" | "error";

const HttpMetrics = () => {
  const [metrics, setMetrics] =
    useState<ObservabilityPipelineHttpMetricsOverview | null>(null);
  const [loadState, setLoadState] = useState<LoadState>("ready");

  // let's use that hook to retrieve an obs pipeline http client
  const client = useObservabilityPipelineHttpClient();
  const clientKey = client?.getKey() || null;

  useEffect(() => {
    async function fetchHttpMetricsOverview() {
      const now = moment().unix();
      const oneDayAgo = moment().subtract(1, "days").unix();

      if (client === null) {
        return;
      }

      try {
        setLoadState("loading");
        const response = await client.getHttpMetricsOverview(oneDayAgo, now);
        setLoadState("loaded");
        setMetrics(response);
      } catch {
        setLoadState("error");
      }
    }

    fetchHttpMetricsOverview();
  }, [clientKey, client]);

  return (
    <>
      {loadState === "loaded" && (
        <pre>{JSON.stringify(metrics, null, "  ")}</pre>
      )}
      {loadState === "loading" && <pre>LOADING</pre>}
      {loadState === "error" && (
        <pre>
          <code>🚨 Error while fetching http-metrics data 🚨</code>
        </pre>
      )}
    </>
  );
};

export default HttpMetrics;
